import Vue from './vue';
import router from './vue-routes';
import store from './vue-store';
import SiteSearch from '../search/SiteSearch.vue';
import components from '../algolia';
import {getLangcode} from './utils';
import './closest-polyfill';

const loadNavbar = () => {
  if (document.querySelector('.site-header')) {
    new Vue({
      el: '.site-header',
      comments: true,
      components: {
        SiteSearch,
        ...components
      },
      data() {
        const scrollContainer = window;

        return {
          scrollContainer,
          activeMenuId: null,
          scrolled: false,
          oldModelNumbers: false,
          mobileMenuVisible: false,
          activeMobileSubMenuId: null,
          searchInitialized: false
        };
      },
      computed: {
        langcode() {
          return getLangcode(this.$route.params.langcode);
        }
      },
      created() {
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
        this.scrollContainer.addEventListener(
          'scroll',
          this.handleScroll
        );
      },
      mounted() {
        this.displayLanguageSwitcher();
      },
      destroyed() {
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('scroll', this.handleScroll);
      },
      methods: {
        displayLanguageSwitcher() {
          const switcher = document.querySelector(
            '.language-switcher'
          );
          const langcode = switcher.parentNode.dataset.langcode;
          switcher.querySelector(
            '.dropdown-toggle'
          ).innerHTML = `<span class="${langcode}"></span>`;
        },
        toggleSearch() {
          this.searchInitialized = true;
          const active = document.body.classList.toggle('search-active');
          if (active) setTimeout(() => this.$refs.search.$refs.input.focus(), 200);
        },
        toggleDropMenu(event) {
          const id = event.target.id.replace('drop-toggle-', '');
          this.activeMenuId = this.activeMenuId === id ? null : id;
        },
        handleDocumentClick(event) {
          // handle drop menu close
          const inDropMenu = event.target.closest('.drop-menu');
          const onDropMenuToggle = event.target.classList.contains(
            'drop-menu-toggle'
          );

          if (!inDropMenu && !onDropMenuToggle) {
            this.hideDropMenu();
          }
        },
        handleKeydown(event) {
          if (event.key === 'Escape') {
            this.hideDropMenu();
            this.hideSearch();
          }
        },
        handleScroll() {
          const y = window.scrollY;
          this.scrolled = y > 48;
        },
        hideSearch() {
          document.body.classList.remove('search-active');
        },
        hideDropMenu() {
          this.activeMenuId = null;
        },
        toggleMobileMenu() {
          const menuChildButtons = document.querySelectorAll('.menu-child-button');
          const menuChildSubnavs = document.querySelectorAll('.menu-child-subnav');

          this.mobileMenuVisible = !this.mobileMenuVisible;
          document.documentElement.classList.toggle(
            'show-menu-mobile'
          );
          this.activeMobileSubMenuId = null;

          let subnavHeight = 0;

          menuChildButtons.forEach(button => {
            button.classList.remove('active');
          });

          menuChildSubnavs.forEach(subnav => {
            if (subnav.classList.contains('active')) {
              subnavHeight = subnav.scrollHeight;
              subnav.style.setProperty('--subnav-height', `${subnavHeight}px`);
              setTimeout(() => {
                subnav.style.setProperty('--subnav-height', '0');
              }, 10);
            }

            subnav.classList.remove('active');
          });
        },
        showMobileSubMenu(event) {
          this.activeMobileSubMenuId = event.target.id.replace(
            'menu-show-',
            ''
          );
        },
        showMobileMenuChildSubMenu(event) {
          const menuChildButtons = document.querySelectorAll('.menu-child-button');
          const menuChildSubnavs = document.querySelectorAll('.menu-child-subnav');

          const currentSubnav = event.target.getAttribute('data-subnav');

          let subnavHeight = 0;

          menuChildButtons.forEach(button => {
            if (button.getAttribute('data-subnav') === currentSubnav) {
              button.classList.toggle('active');
            } else {
              button.classList.remove('active');
            }
          });

          menuChildSubnavs.forEach(subnav => {
            if (subnav.getAttribute('data-subnav-menu') === currentSubnav) {
              subnavHeight = subnav.scrollHeight;
              subnav.classList.toggle('active');
              subnav.style.setProperty('--subnav-height', `${subnavHeight}px`);

              if (subnav.classList.contains('active')) {
                setTimeout(() => {
                  subnav.style.setProperty('--subnav-height', 'auto');
                }, 250);
                subnav.setAttribute('aria-hidden', 'false');
              } else {
                setTimeout(() => {
                  subnav.style.setProperty('--subnav-height', '0');
                }, 10);
                subnav.setAttribute('aria-hidden', 'true');
              }
            } else {

              if (subnav.classList.contains('active')) {
                subnavHeight = subnav.scrollHeight;
                subnav.style.setProperty('--subnav-height', `${subnavHeight}px`);
                setTimeout(() => {
                  subnav.style.setProperty('--subnav-height', '0');
                }, 10);
              }

              subnav.classList.remove('active');
              subnav.setAttribute('aria-hidden', 'true');
            }
          });
        },
        returnToMobileParentMenu() {
          const menuChildButtons = document.querySelectorAll('.menu-child-button');
          const menuChildSubnavs = document.querySelectorAll('.menu-child-subnav');

          let subnavHeight = 0;

          this.activeMobileSubMenuId = null;

          menuChildButtons.forEach(button => {
            button.classList.remove('active');
          });

          menuChildSubnavs.forEach(subnav => {
            if (subnav.classList.contains('active')) {
              subnavHeight = subnav.scrollHeight;
              subnav.style.setProperty('--subnav-height', `${subnavHeight}px`);
              setTimeout(() => {
                subnav.style.setProperty('--subnav-height', '0');
              }, 10);
            }

            subnav.classList.remove('active');
          });
        }
      },
      store,
      router
    });
  }
};

export default loadNavbar;
